var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.competitionData.length > 0)?_c('competition-list-link',{attrs:{"listLayout":_vm.listLayout,"competitionData":_vm.competitionData,"paginationData":_vm.paginationData}}):_c('competition-empty-link',{attrs:{"emptyLayout":_vm.emptyLayout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }